import * as colors from "./colors";
import * as fonts from "./fonts";
import * as themes from "./themes";
export { colors, fonts, themes };